import styled from "styled-components";
import { theme } from "@Styled";

export const FreemiumHeaderWrapper = styled.div<{
    height?: number;
}>`
    width: 100%;
    height: 250px;
    background-color: ${theme.palette.common.tbBlue};
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    z-index: -1;
`;

export const PremiumHeaderWrapper = styled.div`
    width: 100%;
    height: 200px;
    clear: both;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    position: relative;
`;

export const StyledCoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
`;

export const ChoicesText = styled.p`
    margin: 25px;
    color: #000;
    font-weight: bold;
`;

export const Question = styled.h1`
    color: #ffffff;
    font-weight: bold;
    text-align: center;
    word-wrap: break-word; /* Breaks long words naturally */
    overflow-wrap: break-word; /* Ensures words don't overflow */
    line-height: 1.3; /* Improves readability */
    hyphens: auto; /* Ensures proper word breaking */
    margin: auto;
    position: relative;
    padding: 12px 20px;
    background-color: #000;
    border-radius: 14px; /* Fully rounded corners */

    /* Fix for Chrome: Force consistent font size */
    font-size: 28px;
    white-space: normal; /* Prevents text shrinking */

    /* Ensure size adjusts based on screen size */
    @media (max-width: 768px) {
        font-size: 24px;
    }

    @media print {
        font-size: 32px !important; /* Ensures visibility when exporting */
    }
`;

export const HighlightText = styled.div`
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5); /* Soft shadow for glow effect */
    transition: all 0.3s ease; /* Smooth transition for hover effect */
`;

export const GradientBackground = styled.div<{
    startColor: string;
    endColor: string;
}>`
    background: linear-gradient(
        90deg,
        ${(props) => props.startColor},
        ${(props) => props.endColor}
    );
    width: 100%;
    position: relative;
    min-height: 200px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media print {
        -webkit-print-color-adjust: exact;
        background: linear-gradient(
            90deg,
            ${(props) => props.startColor},
            ${(props) => props.endColor}
        );
    }
`;
